import React, { useEffect, useState } from "react";
import WebLottiePlayer from "../WebLottiePlayer";
import colors from "../../constants/colors";
import scaleSize, { isTablet } from "../../utils/scaleSize";
import "./AnimatedBox.css";

interface AnimatedBoxProps {
  isComplete: boolean;
  imageSource: string;
}

const AnimatedBox: React.FC<AnimatedBoxProps> = ({
  isComplete,
  imageSource,
}) => {
  const [progress, setProgress] = useState(0);
  const size = scaleSize(18);
  const strokeWidth = 5;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    if (isComplete) {
      const start = performance.now();
      const duration = 1000;
      const tick = (now: number) => {
        const t = Math.min((now - start) / duration, 1);
        setProgress(t);
        if (t < 1) {
          requestAnimationFrame(tick);
        }
      };
      requestAnimationFrame(tick);
    }
  }, [isComplete]);

  const offset = circumference * (1 - progress);

  return (
    <div className="web-animated-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="web-animated-ring-svg">
        <circle
          stroke={colors.WHITE}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          fill={colors.WHITE}
        />
        <circle
          stroke={colors.BUTTON_PRIMARY_COLOR}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div className="web-animated-ring-inner">
        <WebLottiePlayer
          source={imageSource}
          style={{
            width: scaleSize(8),
            height: scaleSize(8),
          }}
          autoPlay={false}
          loop={false}
        />
      </div>
    </div>
  );
};

export default AnimatedBox;
